import React from 'react';
import _ from 'lodash';

const PartnerErrorMessage = (props: { message?: string }): JSX.Element => (
  <div className="virtual-counter-partner__error error">
    <p>{props.message || '通信環境が不安定です。画面をリロードしてからもう一度お試しください。'}</p>
  </div>
);
export default PartnerErrorMessage;
